import script from "./Empleados.vue?vue&type=script&setup=true&lang=js"
export * from "./Empleados.vue?vue&type=script&setup=true&lang=js"

import "./Empleados.vue?vue&type=style&index=0&id=662be418&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662be418"]])

export default __exports__